import { doc } from 'firebase/firestore'
import React from 'react'

import { Dropdown } from '@components/dropdown.component'
import { ActionIcon } from '@components/mantine/action-icon.component'
import { useAppState } from '@src/app.state'
import { db } from '@src/firebase-app'
import { dbNames } from '@utils/constants'
import { getUserFullName } from '@utils/helpers'
import { useDocument } from 'react-firebase-hooks/firestore'

type MentorCardProps = {
  mentor: any
  removeMentor: (id: string) => void
  resendInvitation?: (email: string) => void
}

export function MentorCard({ mentor, removeMentor, resendInvitation }: MentorCardProps) {
  const { userId, status, inviterId, id } = mentor
  const me = useAppState(state => state.user)
  const [user = {} as any, isLoading] = useDocument(doc(db, dbNames.users, userId))

  if (isLoading) {
    return null
  }

  function renderActions() {
    if (me.id === inviterId || me.id === userId) {
      if (status === 'pending') {
        return (
          <Dropdown
            position="bottom-left"
            cover
            fixedContent
            renderTrigger={({ toggle }) => (
              <ActionIcon
                size="sm"
                icon="ellipsis-v"
                variant="tertiary"
                onClick={toggle}
                aria-label="Mentor options"
              />
            )}
            renderContent={({ close }) => (
              <div className="select-list">
                <button
                  onClick={() => {
                    removeMentor(id)
                    close()
                  }}
                >
                  Remove
                </button>
                {!!resendInvitation && (
                  <button
                    onClick={() => {
                      resendInvitation(
                        user.exists() ? user.get('email') : userId,
                      )
                      close()
                    }}
                  >
                    Resend invitation
                  </button>
                )}
              </div>
            )}
          />
        )
      }

      return (
        <ActionIcon
          size="sm"
          icon="times"
          variant="tertiary"
          onClick={() => {
            removeMentor(id)
          }}
          aria-label="Remove mentor"
        />
      )
    }
  }

  return (
    <div
      className="flex"
    >
      <div className="flex w-full items-center justify-between">
        <span className="mr-4 inline-block">
          {user.exists() ? getUserFullName(user.data()) : userId}
        </span>
        <span
          className="mr-4 inline-block rounded-[var(--base-border-radius)] px-1 py-[2px] text-[13px] font-bold text-grey-900 data-[status=pending]:bg-warning data-[status=accepted]:bg-success data-[status=rejected]:bg-danger"
          data-status={status}
        >
          {status}
        </span>
      </div>
      {renderActions()}
    </div>
  )
}
